import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2Module } from 'angulartics2';
import { QRCodeModule } from 'angularx-qrcode';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';

import {
  CommonRadioGroupModule,
  CopyClipboardModule,
  FormValidationModule,
  PipesModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { PublicOptionsComponent } from './public-options.component';
import { TimeCounterComponent } from './components/time-counter.component';
import { TrColorPickerModule } from '../../components/color-picker/color-picker.module';
import { PublicOptionsService } from './public-options.service';
import { PublicOptionsRoutingModule } from './public-options.routing.module';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    PublicOptionsComponent,
    TimeCounterComponent,
  ],
  imports: [
    NgbModule,
    QRCodeModule,
    CommonModule,
    ReactiveFormsModule,
    CommonRadioGroupModule,
    AuthModule,
    AlertsModule,
    FormValidationModule,
    FormsModule,
    UtilsModule,
    NgSelectModule,
    TrColorPickerModule,
    Angulartics2Module,
    CopyClipboardModule,
    QuillModule.forRoot(),
    PublicOptionsRoutingModule,
    PipesModule,
    FrontendDropdownModule,
    FrontendPullRefreshModule,
  ],
  providers: [PublicOptionsService],
})
export class PublicOptionsModule {}
